import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Config from '../../config';
import Form from '../../view/form';
import Priority from '../../model/priority';
import Priorities from '../../collection/priorities';

import { ask, } from '../../utils/popups';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/priorities.list',

    url() {
        return 'priorities';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/priorities.form',
            clusters: this.options.clusters,
        } );

        const makeDisableUpdateDedelePredicate = privilegeCode => 
            () =>
                !Config.privileges().includes( privilegeCode ) ||
                !['GLOBAL', 'CLUSTER'].includes( Config.level() ) ||

                // Роль уровня кластера может редактировать/удалять только сущности своего кластера;
                // в списке уже только "мои" сущности, но с примесью глобальных;
                // поэтому достаточно только запретить редактировать глобальные
                Config.level() === 'CLUSTER' && 
                    !this.options.paged.current().get( 'cluster' );

        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: {

                disabled: () =>
                    !Config.privileges().includes( 'create_priority' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: () => {
                    const current = new Priority();
                    const binding = form.bind( current );
                    binding.then( () => {
                        if (this.state().cluster && this.state().cluster.id != -1)
                            current.set( 'cluster', this.state().cluster );
                        else if (Config.level() === 'CLUSTER')
                            current.set( 'cluster', Config.cluster() );
                    } );

                    ask( binding,
                        'priority::modal new - title', 'actions::create', 'actions::cancel', 
                        () => this.options.priorities.save( form ) )
                            .then( () => this.options.source.reset( this.options.priorities.models ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                },

            },
            
            edit: {

                disabled: makeDisableUpdateDedelePredicate( 'update_priority' ),

                handler: current => 
                    ask( form.bind( current.clone() ),
                        'priority::modal edit - title', 'actions::save', 'actions::cancel', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() )
            },
            
            destroy: {

                disabled: makeDisableUpdateDedelePredicate( 'delete_priority' ),

                handler: current =>
                    this.destroy( current, 
                        'priority::modal delete - title', 
                        'priority::modal delete - confirmation text' ),
                
            }
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Priorities( this.options.priorities.models );
        this.options.sorted = new Priorities();
        this.options.filtered = new Priorities();
        this.options.paged = new Priorities( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/priorities.list.js